export const CommaFormatted = (amount) => {
    if (amount.length <= 3) {
        return amount;
    } else {
        return new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(parseInt(amount));
    }
}

export const isNumber = (value) => {
    return /^\d+$/.test(value);
}

export const sortInAlphaOrder = (property) => {
    return function (a, b) {
        if ((a[property]).toUpperCase() > (b[property]).toUpperCase())
            return 1;
        else if ((a[property]).toUpperCase() < (b[property]).toUpperCase())
            return -1;
        return 0;
    }
}

export function replaceNull(someObj, replaceValue = "") {
    const replacer = (key, value) => {
      //
      if (typeof value === "number") {
        return value;
      } else if (typeof value === "boolean") {
        return value;
      } else {
        return String(value) === "null" ||
          String(value) === "undefined" ||
          Object.keys(value).length === 0 ||
          String(value) === ""
          ? replaceValue
          : value;
      }
    };  
    return JSON.parse(JSON.stringify(someObj, replacer));
  }